import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material"
import { CloseOutlined } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"

const ModalCargandoDuplicado = ({ open, setOpen, loading, checkTemplate }) => {
  const navigate = useNavigate()

  const handlePrimaryAction = () => {
    if (loading) return

    setOpen(false)

    if (checkTemplate) {
      navigate("/bancodeprecios/templates")
      return
    }

    window.location.reload()
  }

  return (
    <Dialog
      open={open}
      onClose={handlePrimaryAction}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxHeight: "calc(100vh - 100px)",
        },
      }}
    >
      {!loading && (
        <DialogTitle sx={{ pb: 0 }}>
          <IconButton
            aria-label="close"
            onClick={handlePrimaryAction}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
      )}

      <DialogContent
        sx={{
          px: 4,
          py: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            mt: 1,
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography sx={{ fontWeight: 400, fontSize: 16 }}>
            {loading
              ? checkTemplate
                ? i18n.t("Duplicando proyecto como plantilla...")
                : i18n.t("Duplicando Proyecto...")
              : i18n.t("El proyecto se ha duplicado correctamente")}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 4, pb: 3, justifyContent: "center" }}>
        <Button
          type="button"
          color="branded"
          variant="contained"
          disabled={loading}
          sx={{ width: 220, height: 36 }}
          onClick={handlePrimaryAction}
        >
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : checkTemplate ? (
            i18n.t("Ir a plantillas")
          ) : (
            i18n.t("Ir a la página principal")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ModalCargandoDuplicado.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  checkTemplate: PropTypes.bool.isRequired,
}

export default ModalCargandoDuplicado
